import {
    UserIconComponent as SourceUserIconComponent,
} from 'SourceComponent/UserIcon/UserIcon.component';

import './UserIcon.override.style';
import React from "react";

export class UserIconComponent extends SourceUserIconComponent {
    render() {
        const { isActive } = this.props;

        return (
            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 12C12.094 12 13.1432 11.5259 13.9168 10.682C14.6904 9.83807 15.125 8.69347 15.125 7.5C15.125 6.30653 14.6904 5.16193 13.9168 4.31802C13.1432 3.47411 12.094 3 11 3C9.90598 3 8.85677 3.47411 8.08318 4.31802C7.3096 5.16193 6.875 6.30653 6.875 7.5C6.875 8.69347 7.3096 9.83807 8.08318 10.682C8.85677 11.5259 9.90598 12 11 12ZM13.75 7.5C13.75 8.29565 13.4603 9.05871 12.9445 9.62132C12.4288 10.1839 11.7293 10.5 11 10.5C10.2707 10.5 9.57118 10.1839 9.05546 9.62132C8.53973 9.05871 8.25 8.29565 8.25 7.5C8.25 6.70435 8.53973 5.94129 9.05546 5.37868C9.57118 4.81607 10.2707 4.5 11 4.5C11.7293 4.5 12.4288 4.81607 12.9445 5.37868C13.4603 5.94129 13.75 6.70435 13.75 7.5ZM19.25 19.5C19.25 21 17.875 21 17.875 21H4.125C4.125 21 2.75 21 2.75 19.5C2.75 18 4.125 13.5 11 13.5C17.875 13.5 19.25 18 19.25 19.5ZM17.875 19.494C17.8736 19.125 17.6632 18.015 16.731 16.998C15.8345 16.02 14.1474 15 11 15C7.85125 15 6.1655 16.02 5.269 16.998C4.33675 18.015 4.12775 19.125 4.125 19.494H17.875Z" fill="#1E1E1E" />
            </svg>
        );
    }
}

export default UserIconComponent;
